import { render, staticRenderFns } from "./W9ContractTemplate.vue?vue&type=template&id=5fc57b45&scoped=true"
import script from "./W9ContractTemplate.vue?vue&type=script&lang=js"
export * from "./W9ContractTemplate.vue?vue&type=script&lang=js"
import style0 from "./W9ContractTemplate.vue?vue&type=style&index=0&id=5fc57b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc57b45",
  null
  
)

export default component.exports